var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import user_model from "@iscr/models/user_model";
export const handleHealthCreditAlertSeen = (profile, code) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const existingCodes = ((_a = profile.meta) === null || _a === void 0 ? void 0 : _a.dismissed_credit_alerts) || [];
    const dismissed_credit_alerts = Array.isArray(existingCodes) ? [...existingCodes, code] : [code];
    const updProfile = { meta: { dismissed_credit_alerts } };
    yield user_model.save_prof(updProfile, (result) => {
        // update old profile
        if (result) {
            app.user.prof.meta = Object.assign({}, result.profile.meta);
        }
    });
});
